<style scoped>
.header {
  height: 20px;
  text-align: center;
  font-size: 16px;
  color: var(--color-modal-title);
}

.text {
  padding: 20px;
  font-size: 16px;
  text-align: center;
}

.warning {
  color: var(--color-warning);
  text-align: left;
  font-size: 14px;
  padding: 10px 40px;
}

.subtitle {
  color: var(--color-modal-subtitle);
  text-align: center;
  font-size: 14px;
  padding: 10px 16px;
  border-bottom: 1px solid color-mix(in srgb, var(--color-background) 50%, transparent);
  margin: -16px -16px 16px;
}
</style>

<template>
  <Modal
    :value="show"
    width="360"
    @input="$emit('on-cancel', $event)"
  >
    <div
      slot="header"
      class="header"
    >
      {{ headerText }}
    </div>
    <div
      v-if="subtitle"
      class="subtitle"
    >
      {{ subtitle }}
    </div>
    <div
      class="text"
      :class="{ warning }"
    >
      {{ text }}
    </div>
    <div slot="footer">
      <Button
        size="large"
        long
        @click="confirm"
        :disabled="btdisable"
      > {{ btname }} </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'Confirm',
  props: ['show', 'headerText', 'text', 'subtitle', 'btname', 'warning'],
  data: function () {
    return {
      btdisable: false
    }
  },
  watch: {
    show: function (value) {
      if (this.show) {
        this.btdisable = false
        window.addEventListener('keydown', this.confirmOnEnter)
      } else {
        window.removeEventListener('keydown', this.confirmOnEnter)
      }
    }
  },
  methods: {
    confirmOnEnter (event) {
      if (event.keyCode === 13) {
        this.confirm()
      }
    },
    confirm () {
      if (this.btdisable) {
        return
      }
      this.btdisable = true
      this.$emit('confirmed')
    }
  }
}
</script>
